import React, { useState, useEffect } from "react";
import "../../assets/styles/components/model.scss";
import "../../assets/styles/ant/modal.scss";
import {
  Modal,
  Button,
  Space,
  Col,
  Form,
  Select,
  Row,
  Spin,
  message,
} from "antd";
import { Icon } from "@iconify/react";
import {
  mdiClose,
  mdiAlertOutline,
  mdiVanish,
  mdiCheckCircleOutline,
} from "@mdi/js";
import axios from "axios";

interface Props {
  show?: boolean;
  cancelModal?: () => void;
  opd_id?: string;
  nameTitle?: string;
}
const SelectDocter = (props: any) => {
  const [optDockor, setOptDockor] = useState<any>([]);
  const [dockorId, setDockorId] = useState<string>("");
  const [dockor, setDoctor] = useState<any>([]);
  const { opd_id, cancel, nameTitle } = props;

  useEffect(() => {
    axios.get(`/doctor`).then((res) => {
      let data = res?.data?.data;
      setDoctor(data);
    });
  }, []);

  const sendPatient = async () => {
    axios
      .post(`/doctor/patient`, {
        title: "",
        doctor_id: dockorId,
        type: "patient",
        data: {
          id: opd_id,
          name: nameTitle,
          url: `/opd/list/` + opd_id,
        },
      })
      .then((res) => {
        message.success("ทำการส่ง Patient สำเร็จแล้ว!");
        cancel();
      });
  };
  const getSearch = async (search: any) => {
    const code = [];
    let searchData = search ? search : "";
    for (let i = 0; i < dockor.length; i++) {
      if (searchData === "") {
        code.push(
          <Select.Option value={dockor[i]?._id} key={dockor[i]?._id}>
            {dockor[i]?.firstName} {dockor[i]?.lastName}
          </Select.Option>
        );
      } else {
        if (
          dockor[i]?.firstName.substr(0, searchData.length).toUpperCase() ==
          searchData.toUpperCase()
        ) {
          code.push(
            <Select.Option value={dockor[i]?._id} key={dockor[i]?._id}>
              {dockor[i]?.firstName} {dockor[i]?.lastName}
            </Select.Option>
          );
        } else if (
          dockor[i]?.firstName.toUpperCase().indexOf(searchData.toUpperCase()) >
          -1
        ) {
          code.push(
            <Select.Option value={dockor[i]?._id} key={dockor[i]?._id}>
              {dockor[i]?.firstName} {dockor[i]?.lastName}
            </Select.Option>
          );
        }
      }
    }
    setOptDockor(code);
  };
  return (
    <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
      <Col className="gutter-row" span={24}>
        <div className="heading">
          <p>Doctor</p>
        </div>
        <Form.Item
          name="agency"
          rules={[
            {
              required: true,
              message: "กรุณากรอกข้อมูล!",
            },
          ]}
        >
          <Select
            className="col-12 search-one"
            suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
            showSearch
            onSearch={getSearch}
            filterOption={false}
            onChange={(e) => {
              setDockorId(e);
            }}
          >
            {optDockor.length > 0
              ? optDockor
              : dockor.map((item: any, key: number) => (
                  <Select.Option value={item?._id} key={key}>
                    {item?.firstName} {item?.lastName}
                  </Select.Option>
                ))}
          </Select>
        </Form.Item>
      </Col>
      <Col className="gutter-row" span={12}>
        <div className="btn-send">
          <Button
            onClick={cancel}
            style={{
              background: "#ffffff",
              color: "#e76464",
            }}
          >
            ยกเลิก/Cancel
          </Button>
        </div>
      </Col>

      <Col className="gutter-row" span={12}>
        <div className="btn-edit">
          <Button
            onClick={sendPatient}
            style={{
              background: "#4d7e7f",
              color: "#ffffff",
            }}
          >
            ส่งข้อมูล/Send
          </Button>
        </div>
      </Col>
    </Row>
  );
};
const modalSendMessage: React.FC<Props> = ({
  show,
  cancelModal,
  opd_id,
  nameTitle,
}) => {
  return (
    <div className="modal-opd">
      <div>
        <Modal
          visible={show}
          footer={null}
          closable={false}
          centered
          className="modal-custom"
        >
          <div className="text-modal text-left">
            <h5> Send Patient To</h5>
          </div>
          <div className="btn-confirm text-left">
            <SelectDocter
              opd_id={opd_id}
              cancel={cancelModal}
              nameTitle={nameTitle}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default modalSendMessage;
